var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "queued-sidebar" },
    [
      _vm.currentJob.state === "draft" ? _c("queue-draft") : _vm._e(),
      _vm._v(" "),
      _vm.currentJob.state === "select_output"
        ? _c("queue-select-output")
        : _vm._e(),
      _vm._v(" "),
      _vm.isFreeUser
        ? _c(
            "div",
            [
              _vm.currentJob.state === "completed"
                ? _c("queue-complete")
                : _vm._e(),
              _vm._v(" "),
              _vm.currentJob.state === "failed" ? _c("queue-failed") : _vm._e(),
              _vm._v(" "),
              _vm.currentJob.state === "zip" ? _c("queue-zip") : _vm._e(),
              _vm._v(" "),
              _vm.currentJob.state === "not_found"
                ? _c("queue-not-found")
                : _vm._e(),
              _vm._v(" "),
              _vm.currentJob.state === "processing"
                ? _c("div", [_c("queue-processing")], 1)
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isFreeUser
        ? _c(
            "div",
            [
              _vm.currentJob.apiJob === null &&
              _vm.currentJob.state !== "not_found"
                ? _c("queue-prepare")
                : _vm._e(),
              _vm._v(" "),
              _vm.currentJob.apiJob !== null &&
              _vm.currentJob.state === "processing"
                ? _c("queue-processing")
                : _vm._e(),
              _vm._v(" "),
              _vm.currentJob.state === "zip" ? _c("queue-zip") : _vm._e(),
              _vm._v(" "),
              _vm.currentJob.state === "not_found"
                ? _c("queue-not-found")
                : _vm._e(),
              _vm._v(" "),
              _vm.currentJob.state === "completed"
                ? _c("queue-complete")
                : _vm._e(),
              _vm._v(" "),
              _vm.currentJob.state === "failed" ? _c("queue-failed") : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.currentJob.apiJob?.warnings[0]?.code === 666
        ? _c("div", [_c("queue-n-s-f-w")], 1)
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }